import React, { FC } from "react";

interface Props {}
const FilterSeparator: FC<Props> = () => {
  return <hr className="mx-auto my-0 border-white border-b border-b-gray-10" />;
};
export default FilterSeparator;
